import type { FaireProductEntity } from "../../entity_types/product";

export const p_e4q97m9fhd: FaireProductEntity = {
  token: "p_e4q97m9fhd",
  type: "product",
  name: "Shines Next To You Necklace",
  brandToken: "b_eow5j1bbc8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/14edeea781f7b28f89bc7c38fd474c07163a5595a950dc3a8282892cc5a49d2e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/afb2ceb81f05fb748cc3b126273921a53644a939dbcb3b17fe7d0e232529d327.jpeg",
    "https://cdn.faire.com/fastly/9b5164300973a7459bdf05bc8f3e3b7e575c5f863a2440f98f8822ef560db67b.jpeg",
  ],
  priceDollars: 11.43,
  description:
    'The Shines Next To You Necklace is a delicate and elegant piece that adds a subtle touch of glamour to any outfit. With its beautiful shine and dainty design, it makes a statement without being overpowering. \n\n16" long with a 2" extender\n\n18k gold plated, cubic zirconia\n\nLead and Nickel free\n\nMade in China',
  tags: [],
  msrpDollars: 22.85,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:29.580Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
